import { NextPage } from 'next';

import { useIntl } from '@klokhuis/core/Intl';
import { PageLayout } from '@klokhuis/core/PageLayout';
import { ROUTES } from '@klokhuis/core/Routing';

import { HeaderHelpCenter } from './components/HeaderHelpCenter/HeaderHelpCenter';

const HelpCenter: NextPage = () => {
  const { T } = useIntl();

  return (
    <PageLayout
      pageTitle={T('HELP_CENTER_PAGE_TITLE')}
      metaDescription={T('HELP_CENTER_PAGE_METADATA')}
      route={ROUTES.HelpCenter}
      showPropertyLinksGrid={false}
    >
      <PageLayout.MainRaw>
        <HeaderHelpCenter />
      </PageLayout.MainRaw>
    </PageLayout>
  );
};

export default HelpCenter;
